export default __webpack_public_path__ + "static/media/About-Tower-viajes-0@3x.906e5bf5.jpg";